import styled from 'styled-components';
import { media } from 'theme/breakpoints';

export const Card = styled.div`
  height: 100%;
  width: 100%;
  background-color: white;
  border-radius: 4px;
  padding: 48px 0;
  ${media.tablet} {
    padding: 30px 0;
  }
`;

export const Title = styled.h2`
  color: #0a4ed6;
  font-size: 20px;
  font-weight: 800;
  margin: 0;
  line-height: 32px;
  ${media.tablet} {
    font-size: 18px;
    margin-bottom: 1rem;
  }
`;

export const Description = styled.p`
  margin-top: 16px;
  margin-bottom: 0;
  color: #000;
  font-size: 16px;
  font-weight: 500;
  line-height: 28px;
  ${media.tablet} {
    font-size: 14px;
    line-height: 26px;
  }
`;

export const Preview = styled.a`
  &:hover {
    text-decoration: none;
    ${Title} {
      text-decoration: underline;
    }
  }
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
`;
